import { AlignmentType } from "docx";
import type { ResumeTemplateDefinition } from "./types";
import { createDocxResumeDocument } from "./docx-builder";
import { ResumePdfTemplateDocument } from "./pdf-builder";

export const templateThree: ResumeTemplateDefinition<"template-3"> = {
  id: "template-3",
  label: "Corona Grid",
  description:
    "Editorial two-column grid with bold dividers echoing auroral curtains.",
  accentColor: "#111827",
  render: (resume) =>
    createDocxResumeDocument(resume, {
      accentColor: "#111827",
      headingFont: "Helvetica Neue",
      bodyFont: "Arial",
      headerAlignment: AlignmentType.LEFT,
      headingTransform: "title",
      includeOrganizations: true,
      includeHighlights: true,
      contactSeparator: " · ",
      bulletSpacing: 70,
      nameFontSize: 30,
    }),
  renderPdf: (resume) => (
    <ResumePdfTemplateDocument
      resume={resume}
      options={{
        accentColor: "#111827",
        headingFont: "Helvetica Neue",
        bodyFont: "Arial",
        headerAlignment: "left",
        headingTransform: "title",
        includeOrganizations: true,
        includeHighlights: true,
        contactSeparator: " · ",
        bulletSpacing: 70,
        nameFontSize: 30,
      }}
    />
  ),
};
